import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
  OnInit,
} from '@angular/core';

import { DetailsValueComponent, ShimmerComponent } from '@iw/common';
import { IwDecimalPipe } from '@iw/core/pipes';

import { WithdrawalReq } from '../../../entities';
import { WithdrawalStore } from '../../../withdrawal.store';

@Component({
  selector: 'iw-crypto-details',
  imports: [DetailsValueComponent, IwDecimalPipe, ShimmerComponent],
  templateUrl: './crypto-details.component.html',
  styleUrl: './crypto-details.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CryptoDetailsComponent implements OnInit {
  readonly #store = inject(WithdrawalStore);
  withdrawalInfo = input.required<WithdrawalReq>();
  currencySymbol = input<string>();

  estimatedFee = this.#store.estimation;
  loading = this.#store.isEstimateFeePending;

  amount = computed(() => {
    return Math.max(
      (this.withdrawalInfo().amount || 0) - (this.estimatedFee()?.fee || 0),
      0,
    );
  });

  ngOnInit(): void {
    const { amount, fromAccountId, targetCryptoAddress } =
      this.withdrawalInfo();

    this.#store.estimateFee({
      amount,
      fromAccountId,
      targetCryptoAddress,
    });
  }
}
